import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionPageTemplate from 'js/containers/header-region/HeaderRegion.page-template';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';
import { staticImageAssets } from 'js/constants/Paths';

// import svg
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import
import { getSiteMetaData } from 'js/store/app/App.selectors';
import { getCurrentPageDataByUrl } from 'js/store/page-templates/PageTemplates.selectors';

const PageTemplate = (props) => {
  const isRspbPage = props.url === 'rspb' || props.url === 'the-rspb-and-stan-gran';

  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.home]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageDataByUrl(state, props.url);
  });

  const { header = {}, body = {}, name, meta: pageMeta = {} } = pageData;

  const { title = meta.title, description = meta.description, keywords = meta.keywords } = pageMeta;

  useEffect(() => {
    trackPageview({ title: name, path: props.path });
  }, []);

  return (
    <>
      <SiteMetaData title={title} description={description} keywords={keywords} />
      <HeaderRegionPageTemplate
        title={header?.title || ''}
        description={header?.description || ''}
        image={header?.image || ''}
        isRspbPage={isRspbPage}
      />
      <div className="about-page">
        <SvgTextureLineLong color={'#1a8175'} />
        <div className="container">
          <div className="about-page__body wysiwyg">
            {(body?.description || '') !== '' && <div dangerouslySetInnerHTML={{ __html: body.description }} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageTemplate;
